import { Injectable } from '@angular/core';
import { StrapiCollectionEntityApiService } from '@core/data-access';
import {
  ProductManualRecommendationEntity,
  ProductManualRecommendationEntityStrapi,
  ProductManualRecommendationTypeCode,
} from '@product/const/v2';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductManualRecommendationApiService extends StrapiCollectionEntityApiService<ProductManualRecommendationEntityStrapi> {
  constructor() {
    super('manual-product-recommendations');
  }

  getProductManualRecommendationData(productCode: string): Observable<ProductManualRecommendationEntity> {
    return this.getList({
      filters: {
        sourceCode: { $eq: productCode },
      },
    }).pipe(
      map((productManualRecommendations) => {
        const recommendationTypes = [
          ProductManualRecommendationTypeCode.ACCESSORIES,
          ProductManualRecommendationTypeCode.BASE_PRODUCT,
          ProductManualRecommendationTypeCode.SIMILAR,
          ProductManualRecommendationTypeCode.MANDATORY,
        ];

        return recommendationTypes.reduce(
          (acc, typeCode) => ({
            ...acc,
            [typeCode]:
              productManualRecommendations.find((recommendation) => recommendation.typeCode === typeCode) || null,
          }),
          {},
        );
      }),
    );
  }
}
